import React from "react";

const google = window.google;

export default class Map extends React.Component {
  constructor(props) {
    super(props);
    this.map = null;
    this.initialZoom = 16;
    this.minZoom = 14;
    this.maxZoom = 25;
    this.state = {
      zoom: this.initialZoom,
    };
  }

  componentDidMount() {
    let marker, m68Lat;
    m68Lat = new google.maps.LatLng(19.4153441, -99.1832815);
    var mapOptions = {
      zoom: this.state.zoom,
      center: m68Lat,
      panControl: false,
      zoomControl: false,
      scaleControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      scrollWheel: false,
      disableDoubleClickZoom: true,
      gestureHandling: "none", // bloquea gestos táctiles
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
    };
    this.map = new google.maps.Map(
      document.getElementById("soma-map"),
      mapOptions
    );
    marker = new google.maps.Marker({
      position: m68Lat,
      title: "SOMA",
    });
    var styles = [
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#536fa9",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
          {
            color: "#5977ba",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#445c8c",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#5a79b8",
          },
          {
            lightness: 0,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#445c8c",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            color: "#6181c2",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#536fa9",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#536fa9",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            visibility: "off",
          },
          {
            color: "#5977ba",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            saturation: 90,
          },
          {
            color: "#161e2d",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
          {
            color: "#5977ba",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#5977ba",
          },
          {
            lightness: 0,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#5977ba",
          },
          {
            lightness: 0,
          },
          {
            weight: 1.2,
          },
        ],
      },
    ];
    marker.setMap(this.map);
    this.map.setOptions({ styles: styles });
  }

  handleResetZoom = () => {
    if (this.map) {
      this.map.setZoom(this.initialZoom);
      this.setState({ zoom: this.initialZoom });
    }
  };

  handleZoomIn = () => {
    if (this.map) {
      let currentZoom = this.map.getZoom();
      let newZoom = Math.min(currentZoom + 1, this.maxZoom);
      this.map.setZoom(newZoom);
      this.setState({ zoom: newZoom });
    }
  };

  handleZoomOut = () => {
    if (this.map) {
      let currentZoom = this.map.getZoom();
      let newZoom = Math.max(currentZoom - 1, this.minZoom);
      this.map.setZoom(newZoom);
      this.setState({ zoom: newZoom });
    }
  };

  render() {
    return (
      <div style={{ position: "relative", height: "100%", width: "100%" }}>
        <div id="soma-map" style={{ height: "100%", width: "100%" }} />
        <div
          style={{
            position: "absolute",
            top: 10,
            left: 10,
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <button
            onClick={this.handleZoomIn}
            style={{
              fontSize: 20,
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "none",
              background: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              cursor: "pointer",
            }}
          >
            +
          </button>
          <button
            onClick={this.handleZoomOut}
            style={{
              fontSize: 20,
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "none",
              background: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              cursor: "pointer",
            }}
          >
            –
          </button>
          <button
            onClick={this.handleResetZoom}
            style={{
              fontSize: 25,
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "none",
              background: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              cursor: "pointer",
            }}
            title="Reset zoom"
          >
            ⟳
          </button>
        </div>
      </div>
    );
  }
}
